import React from "react";
import { Wifi } from "lucide-react";

function detectBrand(number) {
  const n = number.replace(/\s/g, "");
  if (/^4/.test(n)) return "VISA";
  if (/^5[1-5]/.test(n)) return "MASTERCARD";
  if (/^3[47]/.test(n)) return "AMEX";
  if (/^6/.test(n)) return "RUPAY";
  return "CARD";
}

export function CardPreview({ number, expiry, name, cvv, flipped }) {
  const digits = (number || "").replace(/\D/g, "").padEnd(16, "•");
  const grouped = digits.match(/.{1,4}/g)?.join("  ") || "••••  ••••  ••••  ••••";
  const brand = detectBrand(number || "");

  return (
    <div style={{ perspective: "1000px" }} className="w-full max-w-[340px] mx-auto mb-6">
      <div
        className="relative w-full transition-transform duration-500"
        style={{
          aspectRatio: "1.586",
          transformStyle: "preserve-3d",
          transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
        }}
      >
        {/* Front */}
        <div
          className="absolute inset-0 rounded-2xl p-5 flex flex-col justify-between"
          style={{
            backfaceVisibility: "hidden",
            background: "linear-gradient(135deg, #1E2128 0%, #14171C 100%)",
            border: "1px solid rgba(255,255,255,0.1)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
          }}
        >
          <div className="flex items-center justify-between">
            <div
              className="w-10 h-7 rounded"
              style={{ background: "linear-gradient(135deg,#FF8A00,#FFB347)" }}
            ></div>
            <Wifi size={20} color="rgba(255,255,255,0.6)" style={{ transform: "rotate(90deg)" }} />
          </div>
          <p
            style={{ fontFamily: "'JetBrains Mono', monospace", letterSpacing: "2px", color: "#F5F1EA" }}
            className="text-lg sm:text-xl"
          >
            {grouped}
          </p>
          <div className="flex items-end justify-between">
            <div>
              <p className="text-[9px] uppercase tracking-widest mb-1" style={{ color: "rgba(245,241,234,0.4)" }}>
                Card Holder
              </p>
              <p style={{ fontFamily: "'JetBrains Mono', monospace", color: "#F5F1EA" }} className="text-xs uppercase truncate max-w-[160px]">
                {name || "YOUR NAME"}
              </p>
            </div>
            <div className="text-right">
              <p className="text-[9px] uppercase tracking-widest mb-1" style={{ color: "rgba(245,241,234,0.4)" }}>
                Expires
              </p>
              <p style={{ fontFamily: "'JetBrains Mono', monospace", color: "#F5F1EA" }} className="text-xs">
                {expiry || "MM/YY"}
              </p>
            </div>
            <span style={{ fontFamily: "Fraunces, serif", color: "#1E9AFF" }} className="text-sm italic">
              {brand}
            </span>
          </div>
        </div>

        {/* Back */}
        <div
          className="absolute inset-0 rounded-2xl flex flex-col"
          style={{
            backfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
            background: "linear-gradient(135deg, #1E2128 0%, #14171C 100%)",
            border: "1px solid rgba(255,255,255,0.1)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
          }}
        >
          <div className="w-full h-9 mt-5" style={{ background: "#0B0D10" }}></div>
          <div className="px-5 mt-5 flex items-center justify-end gap-3">
            <div className="flex-1 h-8 rounded" style={{ background: "rgba(255,255,255,0.08)" }}></div>
            <div
              className="h-8 px-3 rounded flex items-center justify-center text-xs italic"
              style={{ background: "#F5F1EA", color: "#0B0D10", fontFamily: "'JetBrains Mono', monospace" }}
            >
              {(cvv || "•••").padEnd(3, "•")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardPreview;
